<p-dialog #mufDialog [(visible)]="visible" [style]="{'max-width': '450px', width: '100%'}"
          header="Multi-User Form Instantiation" [modal]="true" [closable]="false" [responsive]="true">
    <form #mufForm="ngForm" class="inputs-group" novalidate>
        <div class="inputs-group">
            <div class="inputs-group-row">
                <label for="formName" class="inputs-group-row-name">
                    Name:
                </label>
                <div class="inputs-group-row-value">
                    <input [(ngModel)]="newFormName"
                           placeholder="Type Multi-User form instance's name"
                           name="formName"
                           id="formName"
                           type="text"
                           pInputText
                           required/>
                </div>
            </div>
            <div *ngFor="let stage of stages; index as i" class="inputs-group-row">
                <label for="formName" class="inputs-group-row-name">
                    {{ stage.label }}:
                </label>
                <div *ngIf="stage.value.stageTargetType === 2" class="inputs-group-row-value">
                    <p>This is a self tab, the target will be you.</p>
                </div>
                <div *ngIf="stage.value.stageTargetType === 3" class="inputs-group-row-value">
                    <p>Patient.</p>
                </div>
                <div *ngIf="stage.value.stageTargetType === 1" class="inputs-group-row-value">
                    <input #email="ngModel"
                           [(ngModel)]="stagesValue[stage.value.innerTabKey]"
                           [name]="stage.value.innerTabKey"
                           [id]="stage.value.innerTabKey"
                           [pattern]="validationPatterns.email"
                           placeholder="Type the external user email"
                           pInputText
                           type="email"
                           required/>
                    <control-errors
                        [control]="email.control"
                        [errors]="{
                            pattern: 'The email is invalid',
                            emailMaxLength: 'The email cannot exceed {emailMaxLength} characters'
                        }"
                    ></control-errors>
                </div>
                <div *ngIf="stage.value.stageTargetType === 0" class="inputs-group-row-value">
                    <p-dropdown [(ngModel)]="stagesValue[stage.value.innerTabKey]"
                                [options]="stagesUsers[stage.value.id_original]"
                                [name]="stage.value.innerTabKey"
                                [id]="stage.value.innerTabKey"
                                [showClear]="true"
                                [filter]="true"
                                placeholder="Select User"
                                appendTo="body"
                                required>
                    </p-dropdown>
                </div>
            </div>
            <div *ngIf="hasExternalUser">
                <div class="inputs-group-row">
                    <label class="inputs-group-row-value">
                        This will apply to all new users:
                    </label>
                </div>
                <div class="inputs-group-row">
                    <label
                        for="pwd"
                        class="inputs-group-row-name">Password:</label>
                    <div class="inputs-group-row-value">
                        <input #extPassword="ngModel"
                               [(ngModel)]="password"
                               placeholder="Type user password"
                               pInputText
                               type="text"
                               name="pwd"
                               id="pwd"
                               required/>
                        <control-errors [control]="extPassword.control"></control-errors>
                    </div>
                </div>
                <div class="inputs-group-row">
                    <label class="inputs-group-row-name" for="pwdHint">
                        Description:
                    </label>
                    <div class="inputs-group-row-value">
                        <input #extPasswordHint="ngModel"
                               pInputText
                               [(ngModel)]="passwordHint"
                               type="text"
                               id="pwdHint"
                               name="pwdHint"
                               placeholder="Type user password description/hint"
                               required/>
                        <control-errors [control]="extPasswordHint.control"></control-errors>
                    </div>
                </div>
            </div>
            <div class="buttons-panel buttons-panel-top-margin">
                <button pButton label="Cancel" type="button"
                        class="p-button-secondary"
                        (click)="cancelMUFInstantiation()"></button>
                <button pButton label="Create"
                        [disabled]="mufForm.invalid"
                        (click)="instantiateMUF()"
                        class="p-button-primary">
                </button>
            </div>
        </div>
    </form>
</p-dialog>

<warning-dialog
    *ngIf="showWarning"
    [text]="'You must complete this form before continuing. Please fill in the form.'"
    (closed)="showWarning=false">
</warning-dialog>



